var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('router-link',{attrs:{"to":"/mentions-legales"}},[_vm._v("Mentions légales")]),_c('router-link',{attrs:{"to":"/vos-donnees-et-vos-droits"}},[_vm._v("Vos données et vos droits")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }